/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/visualization.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of visualization to be generated.
 * This is required when creating the pipeline through CreateVisualization
 * API.
 * @export
 */
export const ApiVisualizationType = {
  ROC_CURVE: 'ROC_CURVE',
  TFDV: 'TFDV',
  TFMA: 'TFMA',
  TABLE: 'TABLE',
  CUSTOM: 'CUSTOM',
} as const;
export type ApiVisualizationType = (typeof ApiVisualizationType)[keyof typeof ApiVisualizationType];

export function instanceOfApiVisualizationType(value: any): boolean {
  for (const key in ApiVisualizationType) {
    if (Object.prototype.hasOwnProperty.call(ApiVisualizationType, key)) {
      if (ApiVisualizationType[key as keyof typeof ApiVisualizationType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ApiVisualizationTypeFromJSON(json: any): ApiVisualizationType {
  return ApiVisualizationTypeFromJSONTyped(json, false);
}

export function ApiVisualizationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiVisualizationType {
  return json as ApiVisualizationType;
}

export function ApiVisualizationTypeToJSON(value?: ApiVisualizationType | null): any {
  return value as any;
}

export function ApiVisualizationTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApiVisualizationType {
  return value as ApiVisualizationType;
}
